module.exports = __webpack_public_path__ + "img/user_avatar.565f7b6e.png";